import { render, staticRenderFns } from "./ReplacePwaWithMobileApp.vue?vue&type=template&id=0f8d5f7c&"
import script from "./ReplacePwaWithMobileApp.vue?vue&type=script&lang=js&"
export * from "./ReplacePwaWithMobileApp.vue?vue&type=script&lang=js&"
import style0 from "./ReplacePwaWithMobileApp.vue?vue&type=style&index=0&id=0f8d5f7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports